import {createQuestionnaireAPI, createWeezBeeCourseAPI, updateQuestionnaireAPI} from "../../Services/api";
import {SignDocTypes} from "./SignDocLib";

const createQuestionnaire = async ({signDocId, data}) => {
    return await createQuestionnaireAPI({
        signDocId,
        allowedTries: data.examRetries,
        passGrade: data.examPassGrade,
        isUserReview: data.canUserReview,
        isAnonymous: data.isAnonymous
    });
};

const createWeezBeeCourse = async ({signDocId}) => {
    return await createWeezBeeCourseAPI({
        signDocId
    });
};

const updateQuestionnaire = async ({signDocId, data}) => {
    return await updateQuestionnaireAPI({
        signDocId,
        allowedTries: data.examRetries,
        passGrade: data.examPassGrade,
        isUserReview: data.canUserReview,
        isAnonymous: data.isAnonymous
    });
};


export const createSubtype = async ({signDocType, signDocId, subtypeData}) => {
    switch (signDocType) {
        case SignDocTypes.EXAM:
        case SignDocTypes.SURVEY:
            //TODO we should remove questionaire data from here it should be handled in the questionnaire QQQQ
            return await createQuestionnaire({signDocId, data: subtypeData});
        case SignDocTypes.WEEZBEE_COURSE:
            return await createWeezBeeCourse({signDocId});
        default:
            return null;
    }
};

export const updateSubtype = async ({signDocType, signDocId, subtypeData}) => {
    switch (signDocType) {
        case SignDocTypes.EXAM:
        case SignDocTypes.SURVEY:
            return await updateQuestionnaire({signDocId, data: subtypeData});
        case SignDocTypes.WEEZBEE_COURSE:
            return () => {}
        default:
            return null;
    }
};

export const hasSubtype = ({signDocType}) => {
    return [SignDocTypes.EXAM, SignDocTypes.SURVEY, SignDocTypes.WEEZBEE_COURSE].includes(signDocType);
}; 